/* eslint-disable import/named */
import { EditorState, Modifier, SelectionState } from 'draft-js';

import { pipe, test } from 'ramda';

const nullSymbolsFilter = (currentEditorState) => {
  const nullCharacterRegex = /\0/g;
  const currentContent = currentEditorState.getCurrentContent();
  const newContent = currentContent.getBlockMap().reduce((acc, block, currentIndex) => {
    const blockKey = block.getKey();
    const blockText = block.getText();

    if (test(nullCharacterRegex, blockText)) {
      return Modifier.replaceText(
        acc,
        new SelectionState({
          anchorKey: blockKey,
          focusKey: blockKey,
          anchorOffset: currentIndex,
          focusOffset: blockText.length,
        }),
        blockText.replace(nullCharacterRegex, ''),
      );
    }

    return acc;
  }, currentContent);

  return EditorState.push(currentEditorState, newContent, 'replace-text');
};

export const secureOnChange = (onChange) => pipe(nullSymbolsFilter, onChange);
